import React, { FC, useState } from "react";
import { icons } from "../../icons";
import {
  IconBackground,
  Title,
  TitleWrapper,
  Content,
  CloseButton,
  AlertCustom,
} from './styles'
import Warning from './warning.svg'
import Error from './error.svg'
import Info from './info.svg'
import ImageIcon from '../side-bar/icons/images-hover.svg'
import { useTranslation } from "react-i18next";
import Link from "../link";
import SVG from "react-inlinesvg";

interface Notification {
  severity: "info" | "error" | "warning" | "image",
  message: string,
  title: string,
  canClose?: boolean,
  progress?: number,
  isDark?: any,
  customStyles?: any,
  link?: string,
  linkText?: string,
}
const NotificationBlock:FC<Notification> = (props) => {

  const {
    severity,
    message,
    canClose = true,
    title,
    customStyles,
    linkText,
    link,
    // custom
  } = props
  const [t] = useTranslation()
  const [dismissed, setDismissed] = useState(false);

  const handleClose = () => {
    if (!canClose) {
      return;
    }
    setDismissed(true);
  };
  const selectedIcon = (type:string) => {
    switch(type){
      case 'info':
        return Info
      case 'error':
        return Error
      case 'warning':
        return Warning
      case 'image':
        return ImageIcon
      default:
        return Info
    }
  } 

  if (dismissed) {
    return null;
  }

  return (
      <AlertCustom role={severity === 'error' || severity === 'warning' ? 'alert' : 'status'} style={customStyles}>
        <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
          <>
          <IconBackground type={severity}>
            <img src={selectedIcon(severity)} alt="" aria-hidden="true"/>
          </IconBackground>
          <TitleWrapper>
            <Title>
              {title}
            </Title>
            <Content>
              {message}
            </Content>
            {linkText &&
              <Link customStyles={{marginTop: '8px'}} linkText={linkText} link={link}/>
            }
          </TitleWrapper>
          </>
          {canClose &&
            <CloseButton type="button" aria-label={t("CLOSE")} onClick={handleClose}>
              <SVG src={icons.CloseIcon} aria-hidden="true"/>
            </CloseButton>
          }
        </div>
      </AlertCustom>
  )
}


export default NotificationBlock
